import React, { FC } from 'react'
import { AssetDownloadContainer, BodyContent, BodyOuter, MarketoFormContainer } from '../formPage'

//* utils
import { LocaleCodes } from '../../../../constants/localization.constants'
import { cnOverrideForm, cnPrivacyPolicy, renderMarketoOrIframe } from '../../../../utils/cn.utils'
import { correctSlugPrefix, generateThankYouPageURL } from '../../../../utils/link.utils'
import { findTarget } from '../../../../utils/microcopy.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'

//* components
import SEOTags from '../../../global/seoTags'
import FormPageHero from '../formPageHero'
import UngatedAssetDownload from '../ungatedAssetDownload'

type Props = {
  whitePaperData: any
  hasForm: boolean
  marketoFormData: any
  path: string
  locale: string
  availableLocales: any
}

export const PageInner: FC<Props> = ({
  whitePaperData,
  hasForm,
  marketoFormData,
  path,
  locale,
  availableLocales,
}) => {
  let hero = null

  if (!whitePaperData.formIntro) {
    const countryCode = locale.slice(3)
    const englishRecordingRow = `resource.${whitePaperData.number}.RecordingROW.text`
    const globalRecordingRow = `resource.${countryCode}.${whitePaperData.number}.RecordingROW.text`

    whitePaperData.formIntro = findTarget(
      locale === LocaleCodes.ENGLISH.code ? englishRecordingRow : globalRecordingRow,
      whitePaperData.microcopy,
    )
  }

  if (whitePaperData.hero.title) {
    const heroProps = {
      h1Title: whitePaperData.hero.title,
      image: {
        imageSrc: whitePaperData.mainImage.url,
        alt: whitePaperData.mainImage.alt,
      },
      blueFilter: whitePaperData.hero.blueFilter,
      heroBullet: whitePaperData.hero.heroBullets,
      heroSubtitle: whitePaperData.hero.heroSubtitle,
      heroTextCentered: whitePaperData.hero.heroTextCentered,
      heroFontBlack: whitePaperData.hero.heroFontBlack,
      heroEyebrow: whitePaperData.hero.heroEyebrow,
      hasForm: hasForm,
      heroCtaText: findTarget(`resource.seeAllCTA.text`, whitePaperData.microcopy),
    }

    hero = <FormPageHero {...heroProps} />
  }

  const thankYouPageUrl = generateThankYouPageURL(
    '/g/thank-you-whitepaper',
    whitePaperData.thankYouPage,
  )
  let formSuccessHandler

  if (hasForm) {
    formSuccessHandler = (form: any) => {
      if (window && window.hasOwnProperty('MktoForms2')) {
        form.onSuccess(() => {
          window.location.href = correctSlugPrefix(thankYouPageUrl)
          return false
        })
      }
    }

    cnOverrideForm(thankYouPageUrl)
    cnPrivacyPolicy()
  }

  return (
    <>
      <SEOTags
        seoMetadata={whitePaperData.seoMetadata}
        path={path}
        slug={whitePaperData.slug}
        locale={locale}
        availableLocales={availableLocales}
      />

      {hero}

      <BodyOuter $formAlignToBody={whitePaperData.rightColumnAlignment}>
        <div>
          <BodyContent className="AR-WP__Body">
            {whitePaperData.body && renderRichText(whitePaperData.body)}

            <div className="AR-WP__FinePrint">
              {whitePaperData.finePrint && renderRichText(whitePaperData.finePrint)}
            </div>
          </BodyContent>

          {hasForm ? (
            <>
              <MarketoFormContainer $formAlignToBody={whitePaperData.rightColumnAlignment}>
                {(locale !== LocaleCodes.CHINESE.code || whitePaperData.cnFormOverride) && (
                  <div className="AR_WP__FormWrapper">
                    {!whitePaperData.rightColumnAlignment && <span id="AR-WP__Form"></span>}

                    {whitePaperData.formIntro && (
                      <p className="FormIntro">{whitePaperData.formIntro}</p>
                    )}

                    {renderMarketoOrIframe({
                      defaultLocale: locale,
                      marketoFormData: whitePaperData.formOverride || marketoFormData,
                      formSuccessHandler: formSuccessHandler,
                      marketoJsScript: whitePaperData.marketoJsScript,
                      cnFormOverride: whitePaperData.cnFormOverride,
                    })}
                  </div>
                )}
              </MarketoFormContainer>
            </>
          ) : (
            <>
              {whitePaperData.downloadAsset ? (
                <AssetDownloadContainer>
                  <div className="AR_WP__DownloadWrapper">
                    <UngatedAssetDownload data={whitePaperData.downloadAsset} />
                  </div>
                </AssetDownloadContainer>
              ) : null}
            </>
          )}
        </div>
      </BodyOuter>
    </>
  )
}
